import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const SecurityFeatures = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("SecurityFeatures", "home/home_SecurityFeatures_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.SecurityFeatures || { Main: {} };

  return (
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: '600px' }}>
          <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content1}</h5>
          <h1 className="mb-0">{LANGUAGE.Main.Content2}</h1>
        </div>

        <div className="row g-5">
          {/* 用戶資安保障 */}
          <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
            <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
              <div className="service-icon">
                <i className="fa fa-shield-alt text-white"></i>
              </div>
              <h4 className="mb-3">{LANGUAGE.Main.Content3}</h4>
              <p className="m-0">{LANGUAGE.Main.Content4}</p>
            </div>
          </div>

          {/* 資金完全自主 */}
          <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
            <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
              <div className="service-icon">
                <i className="fa fa-wallet text-white"></i>
              </div>
              <h4 className="mb-3">{LANGUAGE.Main.Content5}</h4>
              <p className="m-0">{LANGUAGE.Main.Content6}</p>
            </div>
          </div>

          {/* 策略部署由你掌控 */}
          <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
            <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
              <div className="service-icon">
                <i className="fa fa-user-shield text-white"></i>
              </div>
              <h4 className="mb-3">{LANGUAGE.Main.Content7}</h4>
              <p className="m-0">{LANGUAGE.Main.Content8}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityFeatures;
